module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange@3x-9fa150516935bd320a759303bcf6004f.png";